<template >
  <div>
    <div class="list-group">
      <v-card tile height="100vh" max-height="calc(100% - 100px)" width="240" class="rounded-0 elevation-0">
        <div class="list-group-title">
          Настройки
        </div>

        <v-navigation-drawer permanent>
          <v-list-item-group color="var(--app-dark-blue-1)" v-model="selectedTicker" style="top:8px;">
            <v-list-item dense :key="index" style="min-height:48px;" v-for="(item, index) in items">
              <v-list-item-content>
                <div class="d-flex">
                  <div style="line-height: 1.5;">
                    {{ item.title }}
                  </div>
                </div>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-navigation-drawer>
      </v-card>
    </div>
    <div class="component" v-if="typeof selectedTicker == 'number'">
      <component v-bind:is="items[selectedTicker].content"></component>
    </div>
  </div>
</template>

<script>
import Dictionary from "@/views/ClubShareholders/ChatSettings/Dictionary";
import ReasonsBlock from "@/views/ClubShareholders/ChatSettings/ReasonsBlock";
import ReasonsRejection from "@/views/ClubShareholders/ChatSettings/ReasonsRejection";


export default {
  name: 'users',
  components: {
    Dictionary,
    ReasonsBlock,
    ReasonsRejection

  },

  data: () => ({

    selectedTicker: 0,
    items: [
      {
        title: 'Словарь запрещенных слов',
        content: 'Dictionary',
      },
      {
        title: 'Причины блокировки',
        content: 'ReasonsBlock',
      },
      {
        title: 'Причины отклонения регистрации',
        content: 'ReasonsRejection',
      },



    ],

  }),

  created() {
    if (this.$route.params.selectedTicker) {
      this.selectedTicker = this.$route.params.selectedTicker
    }
  },

  methods: {

  },
  watch: {

  },
}
</script>
<style scoped>
.v-list-item__title {
  font-size: 1rem;
}


.list-group {
  position: fixed;
  display: block;
  margin: 0;
  padding: 0;
  width: 240px;
  max-width: 240px;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 1;

  color: #F8F8F8;
}

.component {
  position: absolute;
  left: 240px;
  width: calc(100% - 240px);

}

.list-group-title {
  font-size: 28px;
  font-weight: 400;
  box-sizing: border-box;
  padding-top: 34px;
  padding-left: 14px;
  border-right: 1px solid rgba(0, 0, 0, 0.15);
}
</style>
